import LoginContainer from '../../containers/auth/login';

interface Props {}

function Login(props: Props) {
  return <LoginContainer />;
}

export default Login;
